<template>
  <div id="pay">
    <mt-popup v-model="show" :closeOnClickModal="0" position="bottom" class="pay-popup">
      <div class="header" @click="cancelClick">
        <div class="close"></div>
        <div class="tip">{{title}}</div>
      </div>
      <div class="pay-money pay-money1" v-show="type==='1'">
        <div class="money">
          ￥{{moneyStr}}
          <span class="tip">/年</span>
        </div>
      </div>
      <div class="pay-money pay-money2" v-show="type==='2'">
        <div class="money">
          ￥{{moneyStr}}
          <span class="tip">/年</span>
        </div>
        <div class="omoney">￥3999.00</div>
      </div>
      <div class="pay-money pay-money3" id="payTypeContent" v-show="type==='3'">
        <div class="content">
          <div class="money-box" v-for="(value,index) in payMoneyData" :id="'recommendType' + value.recommend"
            :key="index" @click="selectPayTypeClick(value)"
            :class="{'defaultMoney': !value.isSel,'selectMoney': value.isSel}">
            <div class="recommend" v-show="value.recommend===1">推荐</div>
            <div class="center">
              <span class="tip1">￥</span>
              <span class="money">{{value.money}}</span>
              <span class="tip2" v-show="value.type===1">&nbsp;/&nbsp;{{value.count}}次</span>
              <span class="tip2" v-show="value.type===2">&nbsp;/&nbsp;{{value.count}}年</span>
            </div>
            <div class="bottom" v-show="value.type===2">
              每次仅需
              <span>{{value.cmoney}}</span> 元
            </div>
            <div class="image" v-show="value.isSel===1"></div>
          </div>
        </div>
      </div>
      <div class="pay-money pay-money4" v-show="type==='4'">
        <div class="money">
          ￥{{money}}
        </div>
      </div>
      <div class="pay-money pay-money4" v-show="type==='5'">
        <div class="money">
          ￥{{money}}
        </div>
      </div>
      <div class="pay-type">
        <div v-if="!iswx">
          <div class="pay-box" v-for="(value, index) in items" :key="value.id"
            @click="selPayTypeClick(1,value,value.id)">
            <img class="icon" :src="value.image" />
            <div>{{value.title}}</div>
            <img class="select" :id="forId(index)" :src="value.isSel?msgImg_s:msgImg_n" />
          </div>
        </div>
        <div v-if="iswx">
          <div class="pay-box" v-for="(value, index) in items2" :key="value.id"
            @click="selPayTypeClick(2,value,value.id)">
            <img class="icon" :src="value.image" />
            <div>{{value.title}}</div>
            <img class="select" :id="forId(index)" :src="value.isSel?msgImg_s:msgImg_n" />
          </div>
        </div>
      </div>
      <div class="protocol" v-show="type==1">
        <img @click="protocolSelClick" id="ruleImg" src="../assets/radio_n.png" />
        <div class="tip">
          我已阅读并同意
          <div @click="protocolClick">《中消通服务协议》</div>
        </div>
      </div>
      <div class="bottom">
        <div class="apply" @click="surePayClick" :style="{backgroundColor:activeStyle}">确认支付</div>
      </div>
      <!-- H5支付form表单 -->
      <div v-html="htmlForm"></div>
      <!-- <iframe style="height:0" :src="wxUrl" frameborder="0"></iframe> -->
    </mt-popup>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
// import pingpp from 'pingpp-js'
export default {
  props: { // 1 中消通支付 2 安全管家支付 3 风险评测 支付 4 应急保障(线下签署) 5 订单列表 订单支付
    show: 0, // 展示
    type: 0,
    payInfo: {
      consultingId: 0, // 应急保障id
      contractOnLine: 0
    },
    money: '',
    orderId: ''
  },
  data () {
    return {
      iswx: false,
      wxUrl: '',
      title: '',
      items: [
        { id: '1', title: '支付宝支付', image: require('../assets/icon_pay_alipay.png'), isSel: 0 },
        { id: '2', title: '微信支付', image: require('../assets/icon_pay_wx.png'), isSel: 0 },
        { id: '3', title: '银行汇款', image: require('../assets/icon_pay_bank.png'), isSel: 0 }
      ],
      items2: [
        { id: '2', title: '微信支付', image: require('../assets/icon_pay_wx.png'), isSel: 0 },
        { id: '3', title: '银行汇款', image: require('../assets/icon_pay_bank.png'), isSel: 0 }
      ],
      msgImg_n: require('../assets/radio_n.png'),
      msgImg_s: require('../assets/radio_s.png'),
      moneyStr: '',
      activeStyle: '#FECDCD',
      isProtocol: 0,
      payMoneyData: [], // 风险评测 金额类型
      payMoneyIndex: -1, // 风险评测 支付金额 类型
      payIndex: 0, // 支付 类型
      payType: '',
      orderInfo: {},
      timerState: '',
      isLogin: 0,
      htmlForm: ''
    }
  },
  methods: {
    forId: function (index) {
      return 'selectImg' + index
    },
    cancelClick: function () {
      // 取消 支付
      this.$emit('payValue', 0)
    },
    selPayTypeClick (index, value, id) {
      this.payIndex = parseInt(id)
      switch (this.payIndex) {
        case 1:
          // this.payType = 'alipay_pc_direct'
          this.payType = 'alipay_wap'
          break
        case 2:
          if (this.utils.isWX()) {
            this.payType = 'wx_jsapi'
          } else {
            this.payType = 'wx_wap'
          }
          break
        case 3:
          this.payType = 'remittance'
          break
      }
      if (index === 1) {
        this.items.forEach((item, index) => {
          item.isSel = 0
        })
      } else {
        this.items2.forEach((item, index) => {
          item.isSel = 0
        })
      }
      value.isSel = 1
    },
    protocolSelClick: function () {
      if (this.isProtocol === 0) {
        document.getElementById('ruleImg').src = this.msgImg_s
        this.isProtocol = 1
      } else {
        document.getElementById('ruleImg').src = this.msgImg_n
        this.isProtocol = 0
      }
    },
    protocolClick: function () {
      // 协议跳转
      window.location.href = 'http://cdn.zxzx119.com/%E4%B8%AD%E6%B6%88%E9%80%9A%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE.pdf'
    },
    checkUserLogin: function () {
      // 检测用户登录状态
      var _this = this
      this.utils.isUserLogin(function (login) {
        if (login === 1) {
          _this.isLogin = 1
        } else {
          _this.isLogin = 0
        }
      })
    },
    checkPayParam: function () {
      if (this.payIndex <= 0) {
        Toast('请选择支付方式！')
        return false
      }
      // if (this.payIndex === 2) {
      //   Toast('暂未开通该支付方式,请选择其他支付方式！')
      //   return false
      // }
      if (this.type === '1') {
        if (this.isProtocol <= 0) {
          Toast('请先阅读《中消通服务协议》！')
          return false
        }
      }
      if (this.type === '3') {
        if (this.payMoneyIndex < 0) {
          Toast('请先选择你购买的支付套餐！')
          return false
        }
      }
      return true
    },
    surePayClick: function () {
      if (this.checkPayParam() === false) {
        return
      }
      if (this.isLogin === 0) {
        Toast('请先登录，再下单！')
        return
      }

      // 微信授权
      if (this.utils.isWX()) {
        if (this.payType === 'wx_jsapi') {
          if (localStorage.getItem('openId') == null) {// 已经授权过有了openid
            let redirectURI = encodeURIComponent(window.location.href)
              window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+this.appIdMall +
            '&redirect_uri=' + redirectURI +
            '&response_type=code&scope=snsapi_base&state=WXPaySTATE&connect_redirect=1#wechat_redirect'
          }
        }
      }

      var _this = this
      var orderUrl = ''
      // 下单  中消通
      if (this.type === '1') {
        orderUrl = this.accountUrl + '/zxOrder/vipOrder'
      }
      // 下单  安全管家
      if (this.type === '2') {
        orderUrl = this.accountUrl + '/safeManager/order'
      }
      // 下单  风险评测
      if (this.type === '3') {
        orderUrl = this.accountUrl + '/zxOrder/saveRiskevalOrderByItem?itemId=' +
          this.payMoneyData[this.payMoneyIndex].id
      }
      // 应急保障
      if (this.type === '4') {
        orderUrl = this.accountUrl + '/zxOrder/submitConsultingOrder?consultingId=' +
          this.payInfo.consultingId + '&contractOnLine=' + this.payInfo.contractOnLine
      }

      if (this.type === '5') {
        this.orderInfo.id = this.orderId
        this.goPay(this.orderId)
        return
      }
      console.log(orderUrl)

      // 下单 发起支付
      this.utils.POST(orderUrl, null, function (response) {
        console.log('下单==========================')
        if (response.message === '未登录') {
          Toast('请先登录，再下单！')
          return
        }
        _this.orderInfo = response.data
        if (_this.type === '4') {
          // 已下单 清除 本地缓存
          localStorage.removeItem('planInfo')
          _this.orderInfo = response.data.order
        }
        // 确认支付
        _this.$emit('payValue', 0)
        if (_this.payIndex === 3) { // 线下 审核汇款
          console.log('===================线下汇款')
          console.log(_this.orderInfo)
          _this.$router.push({ path: 'pay-bank', query: { orderID: _this.orderInfo.id, type: _this.type } })
        } else { // 支付宝 微信支付  下单 支付
          // app 内嵌网页掉支付
          if (parseInt(localStorage.getItem('isApp')) === 1) { // app 内嵌网页掉支付
            if (_this.utils.isIphone()) { // ios 支付
              Toast('iOS -- app内嵌h5支付')
              window.webkit.messageHandlers.startPay.postMessage({ 'payType': _this.payType, 'orderId': _this.orderInfo.id })
            } else {
              Toast('Android -- app内嵌h5支付')
              window.zxzx.startPay(_this.payType, _this.orderInfo.id)
            }
            // 查询支付状态
            _this.payState()
            return
          }
          let param = {}
          if (_this.utils.isWX()) {
            param = {
              code: _this.$route.query.code,
              openId: localStorage.getItem('openId')
            }
          }
          _this.utils.POST(_this.companyUrl + '/newPay/' + _this.payType + '/' + _this.orderInfo.id, param, function (responseObj) {
            console.log(responseObj)
            if (_this.utils.isWX()) {
              _this.launchWXPay(responseObj.data)
              // 查询支付状态
              _this.payState()
              return
            }
            let payUrl = responseObj.data.payUrl
            if (payUrl.indexOf('http') === 0) { // 微信
              console.log('微信支付==============================')
              window.location.href = payUrl
            } else { // 支付宝
              _this.htmlForm = payUrl
              console.log('支付宝微信支付==============================')
              setTimeout(function () {
                document.forms[0].submit()
              }, 500)
            }
            // 查询支付状态
            _this.payState()
          })
        }
      })
    },
    launchWXPay: function (data) { // 微信浏览器发起微信支付 wx_jsapi
      if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(data), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(data))
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(data))
        }
      } else {
        this.onBridgeReady(data)
      }
    },
    randomPwd () {
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let maxPos = chars.length
      let pwd = ''
      for (let i = 0; i < 32; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    onBridgeReady: function (data) {
      let param = data.payParams
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          'appId': param.appId, // 公众号名称，由商户传入
          'timeStamp': param.timeStamp, // 时间戳，自1970年以来的秒数
          'nonceStr': param.nonceStr, // 随机串
          'package': param.package,
          'signType': param.signType, // 微信签名方式：
          'paySign': param.paySign // 微信签名
        },
        function (res) {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        })
    },
    payState: function () {
      // 查询支付状态
      var _this = this
      this.utils.POST(this.companyUrl + '/pay/status/' + this.orderInfo.id, null, function (response) {
        if (response.data.pay_state === '未付款') {
          _this.timerState = setTimeout(function () {
            _this.payState()
          }, 5000)
        } else {
          clearTimeout(_this.timerState)
          Toast('支付成功了！')
          this.$emit('payValue', 1)
        }
      })
    },
    selectPayTypeClick: function (value) { // 选择支付方式
      for (let i = 0; i < this.payMoneyData.length; i++) {
        let item = this.payMoneyData[i]
        item.isSel = 0
        if (item.id === value.id) {
          this.payMoneyIndex = i
          value.isSel = 1
        }
      }
    },
    loadMoneyType: function () { // 获取 风险 评测 支付金类型
      var _this = this
      this.utils.GET(this.accountUrl + '/riskevalItem/getItem', function (response) {
        let data = response.data
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          item.isSel = 0
          if (item.recommend === 1) {
            item.isSel = 1
            _this.payMoneyIndex = i
          }
          if (item.type === 2) {
            item.cmoney = Math.round(item.money / (1200 * item.count))
          }
          item.money = (item.money / 100.00).toFixed(2)
        }
        _this.payMoneyData = data
        setTimeout(function () {
          let dom = document.getElementById('payTypeContent')
          dom.scrollTo(200, dom.scrollTop)
          console.log('水平滚动=============================')
        }, 500)
      })
    },
    // 已下过单，直接支付
    goPay: function (id) {
      let _this = this
      this.$emit('payValue', 0)
      if (this.payIndex === 3) { // 线下 审核汇款
        console.log('===================线下汇款')
        this.$router.push({ path: 'pay-bank', query: { orderID: id, type: this.type } })
      } else { // 支付宝 微信支付  下单 支付
        // app 内嵌网页掉支付
        if (parseInt(localStorage.getItem('isApp')) === 1) { // app 内嵌网页掉支付
          if (this.utils.isIphone()) { // ios 支付
            Toast('iOS -- app内嵌h5支付')
            window.webkit.messageHandlers.startPay.postMessage({ 'payType': this.payType, 'orderId': this.orderInfo.id })
          } else {
            Toast('Android -- app内嵌h5支付')
            window.zxzx.startPay(this.payType, this.orderInfo.id)
          }
          // 查询支付状态
          this.payState()
          return
        }
        let obj = {}
        if (this.utils.isWX()) {
          obj = {
            code: this.$route.query.code,
            openId: localStorage.getItem('openId')
          }
        }
        this.utils.POST(_this.companyUrl + '/newPay/' + _this.payType + '/' + id, obj, function (responseObj) {
          // console.log(responseObj.data.payUrl)
          let payUrl = responseObj.data.payUrl// H5 网页 调支付
          if (payUrl.indexOf('http') === 0) { // 微信
            console.log('微信支付==============================')
            window.location.href = payUrl
          } else { // 支付宝
            _this.htmlForm = payUrl
            console.log('支付宝支付==============================')
            setTimeout(function () {
              document.forms[0].submit()
            }, 500)
          }
          // 查询支付状态
          _this.payState()
        })
      }
    },
    getopenId (code) {
      this.utils.post(this.companyUrl + '/newPay/getOpenId?code=' + code, null, res => {
        if (res.code === 0) {
          localStorage.setItem('openId', res.data)
        }
      })
    },
  },
  watch: {
    $router () {
    },
    isActive: function (val) {
      if (val === true) {
        this.activeStyle = '#C41335'
      } else {
        this.activeStyle = '#FECDCD'
      }
    }
  },
  computed: { // 计算
    isActive: function () {
      if (this.type === '1') {
        if (this.payIndex > 0 && this.isProtocol === 1) {
          return true
        }
      }
      if (this.type === '2') {
        if (this.payIndex > 0) {
          return true
        }
      }
      if (this.type === '3' && this.payMoneyIndex >= 0) {
        if (this.payIndex > 0) {
          return true
        }
      }
      if (this.type === '4') {
        if (this.payIndex > 0) {
          return true
        }
      }
      if (this.type === '5') {
        if (this.payIndex > 0) {
          return true
        }
      }
      return false
    }
  },
  mounted () {
    // 微信 分享
    this.iswx = this.utils.isWX()
    this.moneyStr = this.money
    console.log('支付界面类型000000======---------' + this.type + '-----' + this.moneyStr)
    switch (this.type) {
      case '1':
        this.title = '"中消通-建站、推广"套餐'
        this.moneyStr = '5980.00'
        break
      case '2':
        this.title = '安全管家会员'
        this.moneyStr = '999.00'
        break
      case '3':
        this.title = '查看评测报告'
        this.moneyStr = '0'
        this.loadMoneyType()
        break
      case '4':
        this.title = '支付'
        break
      case '5':
        this.title = '支付金额'
        break
    }
    if (this.utils.isWX()) {
      if (this.$route.query.code !== undefined && localStorage.getItem('openId') === null) {
          // 首次授权重定向
          this.getopenId(this.$route.query.code)
        } else if (localStorage.getItem('openId') === null) {
          let redirectURI = encodeURIComponent(window.location.href)
              window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+this.appIdMall +
              '&redirect_uri=' + redirectURI +
              '&response_type=code&scope=snsapi_base&state=WXPaySTATE&connect_redirect=1#wechat_redirect'
        }
    }

    this.checkUserLogin()
  }
}
</script>

<style scoped>
#pay {
  width: 100%;
}
.pay-popup {
  width: 100%;
  /*height: 400px;*/
}
.header {
  position: relative;
  width: 100%;
  height: 45px;
  line-height: 45px;
  color: #000000;
  font-size: 17px;
  /*background-color: #C41335;*/
  border-bottom: solid #eeeeee 1px;
  box-sizing: border-box;
}
.header .close {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 15px;
  height: 15px;
  padding: 5px;
  background-image: url("../assets/icon-pay-close.png");
  background-size: cover;
  background-position: center center;
}
.header .tip {
  position: absolute;
  left: 0px;
  right: 0px;
  text-align: center;
}
.pay-money {
  position: relative;
  /*background-color: yellow;*/
}
.pay-money1 .money,
.pay-money2 .money {
  position: relative;
  height: 60px;
  padding-top: 30px;
  line-height: 30px;
  font-size: 25px;
  font-weight: bold;
  color: #c41335;
  text-align: center;
}
.pay-money1 .money .tip,
.pay-money2 .money .tip {
  font-weight: normal;
  font-size: 15px;
  color: #000000;
  margin-left: 5px;
}
.pay-money .omoney {
  position: relative;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
  color: #bebebe;
  text-align: center;
  text-decoration: line-through;
}
.pay-money3 {
  width: 100%;
  overflow-x: scroll;
}
.pay-money3 .content {
  position: relative;
  margin-top: 20px;
  margin-bottom: 10px;
  height: 90px;
  width: 560px;
}
.pay-money3 .content .money-box {
  position: relative;
  float: left;
  width: 170px;
  height: 88px;
  margin-left: 10px;
  /*border: solid #cccccc 1px;*/
  /*box-sizing: border-box;*/
  /*background-color: #F9F9F9;*/
}
.pay-money3 .content .money-box:first-of-type {
  margin-left: 15px;
}
.defaultMoney {
  border: solid #cccccc 1px;
  box-sizing: border-box;
  background-color: #f9f9f9;
}
.selectMoney {
  border: solid #c41335 1px;
  box-sizing: border-box;
  background-color: #ffecec;
}
.pay-money3 .content .recommend {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 40px;
  height: 22px;
  line-height: 22px;
  background-color: #c41335;
  color: #ffffff;
  font-size: 13px;
  text-align: center;
}
.pay-money3 .content .center {
  position: absolute;
  top: 25px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
}
.pay-money3 .content .center .tip1 {
  color: #c41335;
  font-size: 13px;
  font-weight: normal;
}
.pay-money3 .content .center .money {
  color: #c41335;
  font-size: 18px;
  font-weight: bold;
}
.pay-money3 .content .center .tip2 {
  color: #333333;
  font-size: 13px;
  font-weight: normal;
}
.pay-money3 .content .bottom {
  position: absolute;
  left: 35px;
  top: 50px;
  width: 100px;
  height: 22px;
  line-height: 22px;
  background-color: #c41335;
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  border-radius: 11px;
}
.pay-money3 .content .bottom span {
  color: #ffff00;
  font-size: 13px;
  font-weight: normal;
  font-weight: bold;
}
.pay-money3 .content .image {
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 16px;
  height: 16px;
  background-image: url(../assets/icon-sel.jpg);
  background-size: cover;
  background-position: center center;
}
.pay-money4 .money {
  position: relative;
  height: 60px;
  padding-top: 30px;
  line-height: 30px;
  font-size: 25px;
  font-weight: bold;
  color: #c41335;
  text-align: center;
}
.pay-type {
  position: relative;
  width: 100%;
  /*top: 30px;*/
  padding-top: 10px;
  height: 190px;
  /*height: 130px;*/
  /*background-color: yellow;*/
}
.pay-box {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  /*background-color: #4BAE4F;*/
}
.pay-box .icon {
  position: absolute;
  top: 20px;
  left: 15px;
  width: 20px;
  height: 20px;
}
.pay-box div {
  position: absolute;
  top: 0px;
  left: 50px;
  width: calc(100% - 60px);
  height: 60px;
  line-height: 60px;
  border-bottom: solid #eeeeee 1px;
  box-sizing: border-box;
}
.pay-box .select {
  position: absolute;
  top: 20px;
  right: 15px;
  width: 20px;
  height: 20px;
}
.protocol {
  position: relative;
  width: 100%;
  height: 65px;
  line-height: 65px;
  /*background-color: yellow;*/
}
.protocol img {
  position: absolute;
  left: 25px;
  width: 22px;
  height: 22px;
  top: 21px;
  object-fit: cover;
}
.protocol .tip {
  position: absolute;
  top: 10px;
  left: 60px;
  width: 250px;
  height: 45px;
  line-height: 45px;
  color: #333333;
  font-size: 14px;
}
.protocol .tip div {
  position: absolute;
  top: 0px;
  left: 95px;
  width: 150px;
  height: 45px;
  line-height: 45px;
  color: #c41335;
  font-size: 14px;
}
.bottom {
  position: relative;
  width: 100%;
  bottom: 0px;
  height: 65px;
  line-height: 65px;
  background-color: #ffffff;
  /*border-top: solid #EEEEEE 1px;*/
  /*box-sizing: border-box;*/
}
.bottom .apply {
  position: absolute;
  top: 10px;
  left: 15px;
  height: 45px;
  line-height: 45px;
  width: calc(100% - 30px);
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  background-color: #c41335;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/pay.vue